const setTabnav = () => {
  const tabnav = document.querySelector('.js-tabnav'),
    btns = tabnav?.querySelectorAll('.js-tabnav-btn'),
    contents = tabnav?.querySelectorAll('.js-tabnav-content');

  btns?.forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.id;

      btns.forEach(btn => {
        btn.classList.remove('is-active')
      })

      this.classList.add('is-active')

      contents.forEach(content => {
        content.classList.remove('is-active')
      })

      document.querySelector('#' + id).classList.add('is-active')
    })
  });
}

export default setTabnav;